import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { selectIsInProgress } from '../../../features/spinner/ducks';
import { selectAccount, selectAccountBalance, fetchInvestedAmountActions, selectAccountInvestedAmount } from '../../../features/auth/ducks';
import { 
  withdrawFundsActions, 
  fetchPaymentsByAccountIdActions, 
} from '../../payments/ducks';
import AccountOverview from '../components/AccountOverview'
import { apiCallIds } from '../../payments/api';
import { selectAccountOverview, fetchAccountOverviewActions } from '../ducks'
import { apiCallIds as overviewApiCallIds } from '../api'
import { Spin } from 'antd';



const mapStateToProps = state => ({
  account: selectAccount(state),
  accountBalance: selectAccountBalance(state),
  isLoading: selectIsInProgress(state, apiCallIds.WITHDRAW_FUNDS),  
  isLoadingAccountOverview: selectIsInProgress(state, overviewApiCallIds.FETCH_ACCOUNT_OVERVIEW),
  accountOverview: selectAccountOverview(state),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      withdrawFunds: withdrawFundsActions.request,
      fetchPaymentsByAccountId: fetchPaymentsByAccountIdActions.request,
      fetchInvestedAmount: fetchInvestedAmountActions.request,
      
      fetchAccountOverview: fetchAccountOverviewActions.request,
    },
    dispatch
  ),
});
@connect(mapStateToProps, mapDispatchToProps)
export default class AccountOverviewContainer extends Component{
  static propTypes = {
    actions: PropTypes.object.isRequired,
    account: PropTypes.object.isRequired,
    accountBalance: PropTypes.number.isRequired,
    accountOverview: PropTypes.object.isRequired,
    isLoading: PropTypes.bool.isRequired,
    isLoadingAccountOverview: PropTypes.bool.isRequired,
  };

  onWithdraw = amount => {
    this.props.actions.withdrawFunds({
      accountId: this.props.account.id,
      amount,
    });
  };

  componentDidMount(){
    const {actions} = this.props
    actions.fetchAccountOverview(
      this.props.account.id
    )
  }


  render(){

    const { isLoading, 
            accountBalance, 
            isLoadingAccountOverview,
            accountOverview,} = this.props

    if (!accountOverview) {
      return (
        <Spin spinning={true}>
          <div className="spin-empty-content" />
        </Spin>
      );
    }

    return(
      <Spin spinning={isLoadingAccountOverview}>
        <AccountOverview
        onWithdraw={this.onWithdraw}
        isLoading={isLoading}
        accountBalance={accountBalance}
        isLoadingAccountOverview={isLoadingAccountOverview}
        accountOverview={accountOverview}
        />
      </Spin>
      
    )
  }

}


// WEBPACK FOOTER //
// ./src/features/overview/containers/AccountOverviewContainer.js